import React from "react";
import logo from "../images/medinice-logo.svg";
import { useRecoilValue } from "recoil";
import { langState } from "./recoilAtom";

const Logo = () => {
  const lang = useRecoilValue(langState);

  return (
    <h2 className="flex">
      <img src={logo} alt="Medinice logo" className="w-auto h-[48px]" />
    </h2>
  );
};

export default Logo;
